import angular from 'angular';
import uiRouter from 'angular-ui-router';

import treatProduct from './treat-product.component';
import copy from './copy/copy.module';
import treatInformation from './information/treat-information.module';
import treatAdminForm from './treat-admin-form/treat-admin-form.module';
import treatAdminList from './treat-admin-list/treat-admin-list.module';
import ingredientForm from './ingredient-form/ingredient-form.module';
import ingredientList from './ingredient-list/ingredient-list.module';
import signOff from './sign-off/sign-off.module';
import usageData from './usage-data/usage-data.module';

import './product.scss';

export default
  angular.module('components.app.treatProduct', [
    uiRouter,
    copy,
    treatInformation,
    treatAdminForm,
    treatAdminList,
    ingredientForm,
    ingredientList,
    signOff,
    usageData
  ])
    .component('treatProduct', treatProduct)
    .config(($stateProvider) => {
      'ngInject';

      $stateProvider
        .state('treatProductEdit', {
          parent: 'app',
          url: '/products/treat/{id:int}',
          component: 'treatProduct',
          resolve: {
            product: ($stateParams, ProductService) =>
              ProductService.getProduct($stateParams.id).then(r => r.data),
            animalTypes: AnimalTypeService =>
              AnimalTypeService.getAnimalTypes().then(r => r.data),
            // TODO: Refactor to OData call
            frequencies: ProductService =>
              ProductService.getFrequencies().then(r => r.data.map((f) => {
                const obj = {};
                obj.Name = f.Name;
                obj.Value = +f.Value;
                return obj;
              })),
            administrationUnits: ProductService =>
              ProductService.getAdministrationUnitsForTreats().then(r => r.data),
            weightUnits: ProductService =>
              ProductService.getWeightUnits().then(r => r.data)
          }
        })
        .state('treatProductCreate', {
          parent: 'app',
          url: '/products/createTreat',
          component: 'treatProduct',
          resolve: {
            product: currentUser => ({
              ProductId: 0,
              MemberId: currentUser.MemberId,
              IsTreat: 1,
              ProductForm: 'Treat(s)'
            }),
            animalTypes: AnimalTypeService =>
              AnimalTypeService.getAnimalTypes().then(r => r.data),
            // TODO: Refactor to OData call
            frequencies: ProductService =>
              ProductService.getFrequencies().then(r => r.data.map((f) => {
                const obj = {};
                obj.Name = f.Name;
                obj.Value = +f.Value;
                return obj;
              })),
            administrationUnits: ProductService =>
              ProductService.getAdministrationUnitsForTreats().then(r => r.data),
            weightUnits: ProductService =>
              ProductService.getWeightUnits().then(r => r.data)
          }
        });
    })
    .name;



// WEBPACK FOOTER //
// ./components/app/product/treat-product.module.js